module.exports = "/_next/static/images/cebab4d964dffd810c12dc5e5e1dbc3a-slide-1-small.png.webp";